import script from "./CharityCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CharityCard.vue?vue&type=script&setup=true&lang=js"

import "./CharityCard.vue?vue&type=style&index=0&id=bc6f0444&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc6f0444"]])

export default __exports__